import React from "react";
import { AppVersionStatusCellTemplate } from "themes/administration/app-release/components";

function AppVersionStatusCell(props) {
    return <AppVersionStatusCellTemplate {...props} />;
}

export default AppVersionStatusCell;
